import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const MenuIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="M3 19h18v-2H3zm0-6h18v-2H3zm0-8v2h18V5z" />
  </BaseIcon>
)
